import { Filter } from '../interfaces/filter';

export const Filters: Filter[] = [
  {
    db_key: 'pct_author',
    display_key: 'Author',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pct_callbacknumber',
    display_key: 'Callback phone',
    options: [],
    displayed: true,
    filterType: 'textAutocomplete',
  },
  {
    db_key: 'pct_component',
    display_key: 'Component',
    options: [],
    displayed: true,
    filterType: 'component',
  },
  {
    db_key: 'pct_responsename',
    display_key: 'Contact',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pct_responseemail',
    display_key: 'Contact mail',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pct_company',
    display_key: 'Company',
    options: [],
    displayed: true,
    filterType: 'textAutocomplete',
  },
  {
    db_key: 'pct_countrycode',
    display_key: 'Country',
    options: [''],
    displayed: true,
    filterType: 'country',
  },
  {
    db_key: 'pct_creator',
    display_key: 'Creator',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pct_initialdescription',
    display_key: 'Description',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pct_has_solution',
    display_key: 'Has solution',
    options: ['true', 'false'],
    displayed: true,
    filterType: 'exact',
  },
  {
    db_key: 'id',
    display_key: "Id",
    options: [],
    displayed:true,
    filterType: 'freeSearch'
  },
  {
    db_key: 'pct_issuetype',
    display_key: 'Issue type',
    options: [],
    displayed: true,
    filterType: 'issuetype',
  },
  {
    db_key: 'pkeywords',
    display_key: 'Keyword',
    options: [],
    displayed: true,
    filterType: 'pKeyword'
  },
  {
    db_key: 'updatedAt',
    display_key: 'Last Updated',
    options: [],
    displayed: true,
    filterType: 'dateRange',
  },
  {
    db_key: 'pct_organization',
    display_key: 'Organization',
    options: [],
    displayed: true,
    filterType: 'exact',
  },
  {
    db_key: 'pct_product',
    display_key: 'Product',
    options: [],
    displayed: true,
    filterType: 'product',
  },
  {
    db_key: 'pct_severity',
    display_key: 'Severity',
    options: [],
    displayed: true,
    filterType: 'severity',
  },
  {
    db_key: 'pct_status',
    display_key: 'Status',
    options: [],
    displayed: true,
    filterType: 'statusGranulated',
  },
  {
    db_key: 'pct_supportlevel',
    display_key: 'Supportlevel',
    options: ['1', '2', '3'],
    displayed: true,
    filterType: 'exact',
  },
  {
    db_key: 'pct_system_version',
    display_key: 'System version',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pde_description',
    display_key: 'Ticket Content',
    options: [],
    displayed: true,
    filterType: 'freeSearch',
  },
  {
    db_key: 'pct_status',
    display_key: 'Ticket Status',
    options: ['open', 'closed'],
    displayed: true,
    filterType: 'exact',
  },
  {
    db_key: 'pct_tickettype',
    display_key: 'Ticket type',
    options: [],
    displayed: true,
    filterType: 'tickettype',
  },
  {
    db_key: 'pct_user',
    display_key: 'User',
    options: [],
    displayed: true,
    filterType: 'textAutocomplete',
  },
  {
    db_key: 'pct_useremail',
    display_key: 'User mail',
    options: [],
    displayed: true,
    filterType: 'textAutocomplete',
  },
];  